import { skipToken, useQuery } from "@tanstack/react-query";
import { storiesKeys } from "Api/Queries/Stories/useStoriesQuery";
import {
  getStoriesPublicID,
  type StoryDetailDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const useStoryDetailQuery = (publicID?: string | null) =>
  useQuery<StoryDetailDto>({
    queryKey: storiesKeys.detail(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() => getStoriesPublicID(publicID))
      : skipToken,
  });
